import Tile from './Tile.js';
import OSM from '../source/OSM.js';
import {ATTRIBUTION} from 'ol/source/OSM.js';
import XYZ from '../source/XYZ.js';
import Group from './Group.js';
import TileWMS from '../source/TileWMS.js';

class Background {

    static create(options = {}) {
        const layerName = options.SeedKey || options.Name || '';

        const factory = new Background(options);

        return factory.createLayer(layerName, options);
    }

    constructor(options = {}) {
        this.baseUrl = options.baseUrl || '';
        this.azureAttribution = `© ${new Date().getFullYear()} TomTom, Microsoft`;
    }

    createLayer(layerName, options) {

        if (options.ServerURL && options.Type == 'ServiceLayer') {
            function tileLoadFunction(tile, src) {
                const client = new XMLHttpRequest();
                client.open('GET', src);
                if (options.Authorization) 
                    client.setRequestHeader('Authorization', options.Authorization);
                client.responseType = 'arraybuffer';
                client.onload = function () {
                    const blob = new Blob([new Uint8Array(client.response)], {type: 'image/png'});
                    const imageUrl = URL.createObjectURL(blob);
                    tile
                        .getImage()
                        .src = imageUrl;
                    tile
                        .getImage()
                        .onload = () => tile.setState(2);
                    tile
                        .getImage()
                        .onerror = () => tile.setState(3);
                };
                client.onerror = () => tile.setState(3);
                client.send();
            }

            const source = new TileWMS({
                url: options.ServerURL + '&' + options.AdditionalParameters,
                tileLoadFunction: tileLoadFunction,
                params: {
                    'LAYERS': options.Layers,
                    'VERSION': options.Version,
                    'TRANSPARENT': true
                },
                serverType: options.ServerType,
                projection: 'EPSG:' + options.EPSG,
                wrapX: false
            });
            return new Tile({name: layerName, source});
        }

        if (layerName.includes('Open Street Map Cycle')) {
            return new Tile({
                name: 'Open Cycle Map',
                source: new OSM({
                    attributions: [
                        'All maps © <a href="https://www.opencyclemap.org/">OpenCycleMap</a>', ATTRIBUTION
                    ],
                    url: `https://{a-c}.tile.thunderforest.com/cycle/{z}/{x}/{y}.png?apikey=${options.APIKey}`
                }),
                wrapX: false,
                noWrap: true
            });
        }

        if (layerName.includes('Open Street Map /Smooth/')) {
            return new Tile({
                name: 'Open Street Map /Smooth/',
                source: new OSM({imageSmoothing: true}),
                wrapX: false,
                noWrap: true
            });
        }

        if (layerName.includes('Open Street Map Transport')) {
            return new Tile({
                name: 'Open Street Map Transport',
                source: new XYZ({
                    url: `https://tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=${options.APIKey}`,
                    attributions: '© <a href="https://www.thunderforest.com/">Thunderforest</a> © OpenStreetMap c' +
                            'ontributors'
                }),
                wrapX: false,
                noWrap: true
            });
        }

        if (layerName.includes('Open Street Map')) {
            return new Tile({
                name: 'Open Street Map',
                source: new OSM({imageSmoothing: false, interpolate: false}),
                wrapX: false,
                noWrap: true
            });
        }

        if (layerName.includes('ArcGIS Online')) {
            return new Tile({
                name: 'ArcGIS Online',
                source: new XYZ({
                    attributions: 'Tiles © ArcGIS',
                    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/' +
                            'tile/{z}/{y}/{x}'
                })
            });
        }

        if (layerName.includes('Azure Map Road')) {
            return this.createAzureTile('Azure Map Road', 'microsoft.base.road');
        }

        if (layerName.includes('Azure Map Aerial')) {
            return this.createAzureTile('Azure Map Aerial', 'microsoft.imagery');
        }

        if (layerName.includes('Azure Map Weather Radar')) {
            return new Group({
                name: 'Azure Map Weather Radar Group',
                layers: [
                    this.createAzureTile('Base Road', 'microsoft.base.road'),
                    this.createAzureTile('Radar', 'microsoft.weather.radar.main', 0.6)
                ]
            });
        }
        return null;
    }

    createAzureTile(name, tilesetId, opacity = 1) {
        return new Tile({
            name,
            opacity,
            source: new XYZ(
                {url: `${this.baseUrl}&tilesetId=${tilesetId}`, crossOrigin: 'anonymous', attributions: this.azureAttribution}
            )
        });
    }

}

export default Background;